/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { ConfigurationVariables } from "../config";

import { getBearerToken } from "../utils/utility";

import { RBM_ACCESS_TOKEN_STORAGE_NAME } from "../utils/constants";

export const buildingsManagementAPI = createApi({
	reducerPath: "buildingsManagementAPI",
	baseQuery: fetchBaseQuery({
		baseUrl: ConfigurationVariables.RBM_API_BASE_URL,
		prepareHeaders: async (headers) => {
			try {
				headers.set("authorization", await getBearerToken(RBM_ACCESS_TOKEN_STORAGE_NAME));
			} catch (error) {
				console.error(error);
			}

			return headers;
		}
	}),
	endpoints: (builder) => ({
		getOrgLists: builder.query({
			query: () => ({
				url: `/api/RootOrganisations/LCBS`
			})
		}),
		getOrgMetadata: builder.query({
			query: ({ orgId }: { orgId: string }) => ({
				url: `/api/v1/metadata/LCBS/${orgId}`
			})
		}),
		getOrgSiteLists: builder.query({
			query: ({ orgId }: { orgId: string }) => ({
				url: `/api/v1/Nodes/LCBS/${orgId}/${orgId}/descendant-nodes/Site`
			}),
			keepUnusedDataFor: 0
		}),
		getUserSettingsDetails: builder.query({
			query: () => ({
				url: `/api/user-settings?allDetails=true`
			})
		})
	})
});

// Export hooks for usage in functional components
export const {
	useGetOrgListsQuery,
	useGetOrgMetadataQuery,
	useGetOrgSiteListsQuery,
	useGetUserSettingsDetailsQuery
} = buildingsManagementAPI;